import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
  selector: "app-asset-select-renderer",
  templateUrl: "./asset-select-renderer.component.html",
  styleUrls: ["./asset-select-renderer.component.scss"]
})
export class AssetSelectRendererComponent implements ICellRendererAngularComp {
  params: any;
  
  assetList: any[] = [];       // Dropdown items
  selectedAssets: any[] = [];  // ngModel binding

  agInit(params: any): void {
    this.params = params;

    // Build dropdown list
    this.assetList = (params.data?.unassignedAssets || []).map((x: string, i: number) => ({
      id: i,
      name: x
    }));
    
    // Load pre-selected assets
    if (Array.isArray(params.data?._selectedAssets)) {
      this.selectedAssets = [...params.data._selectedAssets];
    }
          console.log('Selected assets now:7', this.selectedAssets);
  }
  

  onChange() {
    // ✅ Store selected dropdown values into row data
    this.params.data._selectedAssets = [...this.selectedAssets];
  
    // ✅ OPTIONAL sync to parent array (kept only for UI reference)
    const parent = this.params.context?.componentParent;
    const idx = this.params.node?.rowIndex;
    if (parent && typeof idx === 'number') {
      parent.selectedBandformultiple[idx] = [...this.selectedAssets];
    }
          console.log('Selected assets now:6', this.selectedAssets);
    // ✅ Only refresh the cell renderer (not full grid)
    this.params.api.refreshCells({
      rowNodes: [this.params.node],
      force: false
    });
  }
  
  
  
  
  
  

  refresh(params: any): boolean {
    this.params = params;
    this.assetList = (params.data?.unassignedAssets || []).map((x: string, i: number) => ({ id: i, name: x }));
    this.selectedAssets = Array.isArray(params.data?._selectedAssets) ? [...params.data._selectedAssets] : [];
    return true; // ✅ important so the renderer rebinds when row changes
  }
  
  
  
  
  // ✅ Check if all items selected
  isAllSelected() {
    return this.assetList.length > 0 && this.selectedAssets.length === this.assetList.length;
  }

// For all select/deselect assets
toggleSelectAll() {
  if (this.isAllSelected()) {
    this.selectedAssets = [];
  } else {
    this.selectedAssets = this.assetList.map(a => a.name);
  }
        console.log('Selected assets now:5', this.selectedAssets);
  this.onChange();
}

  toggleSingle(item: any, event: any) {
    if (event.target.checked) {
      if (!this.selectedAssets.includes(item.name)) {
        this.selectedAssets = [...this.selectedAssets, item.name];
      }
    } else {
      this.selectedAssets = this.selectedAssets.filter(x => x !== item.name);
    }
        console.log('Selected assets now:4', this.selectedAssets);
    this.onChange();
  }
  toggleSelectAllClick() {
    if (this.isAllSelected()) {
      this.selectedAssets = [];
    } else {
      // store only names (strings)
      this.selectedAssets = this.assetList.map(a => a.name);
    }
   console.log('Selected assets now:1', this.selectedAssets);
    // ✅ update parent and grid
    this.onChange();
  }
  
  toggleSingleClick(item: any) {
     console.log('Toggling item:', item);
    if (this.selectedAssets.includes(item.name)) {
      this.selectedAssets = this.selectedAssets.filter(x => x !== item.name);
    } else {
      this.selectedAssets = [...this.selectedAssets, item.name];
    }
    
    // ✅ update parent and grid
    this.onChange();
  }
  toggleItem(item: any) {
    console.log('Toggling item:**', item);
    if (this.selectedAssets.includes(item.name)) {
      this.selectedAssets = this.selectedAssets.filter(x => x !== item.name);
    } else {
      this.selectedAssets = [...this.selectedAssets, item.name];
    }
    console.log('Selected assets now:3', this.selectedAssets);
    this.onChange();
  }

  block(e: Event) {
    e.stopPropagation();
    e.preventDefault();
  
  }



  

  
  
  






}
